import { masterData } from "../utils/data";
import {
  MASTER_DATA,
  RECENT_SEARCHES,
  SEARCH_KEYWORDS,
  SUGGESTED_KEYWORDS,
} from "../utils/endpoints";
import { API_HEADERS, buildApiUrl, extraHeaders } from "../utils/utils";

// Fetch recent searches
export const fetchRecentSearches = async ({
  middleware,
  userDetails,
}: {
  middleware: string;
  userDetails: any;
}) => {
  try {
    const response = await fetch(
      buildApiUrl(middleware, RECENT_SEARCHES, "m=true&cn=in"),
      {
        method: "GET",
        headers: {
          ...API_HEADERS,
          ...extraHeaders(userDetails || {}),
        },
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();

      if (data && Array.isArray(data)) {
        const recentSearches: string[] = data
          .map((item) => {
            return item.label;
          })
          .filter((item) => item && item.trim().length > 0);

        return recentSearches;
      } else {
        return [];
      }
    } else {
      console.error("Failed to fetch recent searches:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching recent searches:", error);
    return [];
  }
};

// search keywords
export const searchKeywordsApi = async ({
  query,
  middleware,
}: {
  query: string;
  middleware: string;
}) => {


  // for developement
  // const suggestions = "Java|Java / J2EE|java 8|Java Agents|Java Android|Java Api|Java Applets|Java Architect|java backend|java backend developer|Java Bean|Java Beans / EJB 3.0|Java C|Java C#|Java C++|Java C++ C#|Java Card|Java Code|Java Consultant|Java Database Connectivity|Java Designers|Java Developer|Java Developer Core Java|Java Developer Fresher|Java Developer Java|java development|Java Devloper|Java Doc|Java Eclipse|Java EE|Java Engineer|Java Expert|Java Frameworks|Java Fresher|java full stack|java full stack developer|Java FX|Java GUI|Java Hadoop|Java IDE|Java J2EE|Java J2EE C C|Java J2Ee Developer|Java J2EE Manager|Java J2EE Project Manager|Java J2EE Spring|Java J2EE Spring Hibernate|Java J2EE Struts|Java J2EE Struts Spring Hibernate|JAVA JDBC|Java JEE|Java JEE Hibernate Spring|java lead|Java Mail|Java Network Programming|Java OR C#|Java OR J2EE|Java Oracle|JAVA PHP|Java PL SQL Kenan|Java Professional|Java Programmer|java programming|Java Project Manager|Java Python|Java SAP|Java Script|Java SE|Java Server Pages|Java Software Developer|Java Spring|java spring boot|Java Spring Hibernate|Java Swing|Java Swings|Java Technologies|Java Trainee|Java Trainer|Java VB|Java/J2EE|Java/J2EE Developer|Java2D|JavaBean|JavaBeans|JavaCard|JavaDoc|javaEE|JavaFX|JavaMail|JavaScript|JavaScript InfoVis Toolkit|JavaScriptMVC|JavaSE|JavaServer Faces"
  //       .split("|")
  //       .map((item) => item.trim())
  //       .filter((item) => item.length > 0);
  // return suggestions;


  if (!query.trim()) {
    return [];
  }

  try {
    const response = await fetch(
      buildApiUrl(
        middleware,
        SEARCH_KEYWORDS,
        `q=${encodeURIComponent(query)}&random=${Math.floor(
          Math.random() * 10000
        )}&type=kwd`
      ),
      {
        method: "GET",
        headers: API_HEADERS,
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.text();
      // Parse the pipe-separated string response
      const suggestions = data
        .split("|")
        .map((item) => item.trim())
        .filter((item) => item.length > 0);
      return suggestions;
    } else {
      console.error("Failed to fetch keyword suggestions:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching keyword suggestions:", error);
    return [];
  }
};

// fetch keywords suggestions
export const suggestedKeywordsApi = async ({
  query,
  middleware,
}: {
  query: string;
  middleware: string;
}) => {
  try {
    const response = await fetch(
      buildApiUrl(
        middleware,
        SUGGESTED_KEYWORDS,
        `q=${query}&random=${Math.floor(Math.random() * 10000)}`
      ),
      {
        method: "GET",
        headers: API_HEADERS,
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();

      if (data && Array.isArray(data)) {
        const suggestions = data
          .map((item) => {
            if (typeof item === "string") {
              return item;
            } else if (item && typeof item === "object" && item.text) {
              return item.text;
            } else if (item && typeof item === "object" && item.name) {
              return item.name;
            }
            return String(item);
          })
          .filter((item) => item && item.trim().length > 0);
        return suggestions;
      } else {
        return [];
      }
    } else {
      console.error("Failed to fetch suggested keywords:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching suggested keywords:", error);
    return [];
  }
};

// fetch master-data
export const fetchMasterDataApi = async ({
  middleware,
  userDetails,
}: {
  userDetails: any;
  middleware: string;
}) => {

  // =====> for development
  // return {
  //   topCities: masterData?.topCities || [],
  //   regionAndStates: masterData?.regionAndStates || [],
  //   internationalLocations: masterData?.internationalLocations || [],
  // }


  try {
    const response = await fetch(
      buildApiUrl(
        middleware,
        MASTER_DATA,
        `channelId=${userDetails?.channel_id || 1}&subChannelId=${
          userDetails?.subhchannel_id || 1
        }`
      ),
      {
        method: "GET",
        headers: API_HEADERS,
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return {
        topCities: data?.topCities || [],
        regionAndStates: data?.regionAndStates || [],
        internationalLocations: data?.internationalLocations || [],
      };
    }
  } catch (error) {
    console.error("Error fetching master data:", error);
  }
};
